import changePassword from './change-password.json';

export default {
  changePassword,
};
